import { render, staticRenderFns } from "./ObjectiveBox.vue?vue&type=template&id=5ce4dc20"
import script from "./ObjectiveBox.vue?vue&type=script&lang=js"
export * from "./ObjectiveBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports